import {
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
  provideZoneChangeDetection,
} from '@angular/core';
import {
  AuthModule,
  UserModule,
} from '@ups/xplat/web/features';
import {
  MENU_SERVICE_TOKEN,
  MenuService,
} from '@ups/common/menu';
import { DynamicRenderModule } from '@ups/xplat/web/dynamic-render';

// import { LayoutModule } from '@ups/xplat/web/layout';

import { LoadingBarModule } from '@ngx-loading-bar/core';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';

import { CoreModule } from './core/core.module';
import { SharedModule } from './features/shared/shared.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

@NgModule({
  imports: [
    CoreModule,
    SharedModule,
    AppRoutingModule,
    AuthModule,
    UserModule,
    DynamicRenderModule,
    LoadingBarHttpClientModule,
    LoadingBarRouterModule,
    LoadingBarModule,
  ],
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  providers: [
    // Angular 21 defaults to zoneless; this app reaches the shared UpsCoreModule
    // via UpsIonicCoreModule and opts into zone-based CD here (WI 32149).
    provideZoneChangeDetection(),
    {
      provide: MENU_SERVICE_TOKEN,
      useClass: MenuService,
    },
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
